<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="银行流水号"
            v-model="query.tradeNo"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="客户账户名称"
            v-model="query.accountName"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="payTime"
            type="daterange"
            range-separator="-"
            start-placeholder="收付开始日期"
            end-placeholder="收付结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            clearable
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="合约公司账户名称"
            v-model="query.contractAccountName"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="流水序列号"
            v-model="query.flowCode"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="客户名称"
            v-model="query.customerName"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="销售姓名"
            v-model="query.ownerUserName"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="核销编号"
            v-model="query.verifyCode"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-date-picker
          v-model="query.collectionPeriod"
          type="month"
          value-format="yyyy-MM"
          style="width: 100%"
          placeholder="归属账期">
        </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="verifyTime"
            type="datetimerange"
            range-separator="-"
            start-placeholder="核销开始日期"
            end-placeholder="核销结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            clearable
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="关联订单编号"
            v-model="query.orderNo"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-select
            placeholder="请选择订单类型"
            v-model="query.orderType"
            style="width:100%;"
          >
            <el-option
              v-for="item in orderTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain size="mini" @click="getPaymentList(undefined)"
          >查询</el-button
        >
        <el-button plain size="mini" @click="reset">重置</el-button>
        <el-button plain size="mini"  v-auth="'export'" @click="exportFun" v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
      </div>
    </div>

    <div class="content-wapper">
      <el-table :data="payInfos" size="mini" :border="true">
        <el-table-column
          prop="verifyCode"
          width="200"
          label="核销编号"
        ></el-table-column>
        <el-table-column
          prop="tradeNo"
          width="200"
          label="银行流水号"
        ></el-table-column>
        <el-table-column
          prop="flowCode"
          width="150"
          label="流水序列号"
        ></el-table-column>
        <el-table-column
          prop="verifyAmount"
          width="100"
          label="核销金额"
        ></el-table-column>
        <el-table-column prop="verifyTime" label="核销时间"></el-table-column>
        <el-table-column
          prop="ownerUserName"
          label="销售姓名"
        ></el-table-column>
        <el-table-column prop="collectionPeriod" label="归属账期"></el-table-column>
        <el-table-column prop="verifyTypeName" label="核销类型"></el-table-column>
        <el-table-column
          prop="operatorName"
          width="120"
          label="操作人"
        ></el-table-column>
        <el-table-column  label="操作"    fixed="right"  width="400">
          <template slot-scope="scope">
            <el-button
              v-auth="'view'"
              @click="handleOrdersClick(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              v-auth="'edit'"
              v-if="scope.row.finishState != 1"
              type="text"
              size="small"
              @click="ordinaryEditor(scope.row, 1)"
              >编辑</el-button
            >
            <el-button
              v-auth="'reverse'"
              v-if="scope.row.finishState != 1"
              type="text"
              size="small"
              @click="reverseVerification(scope.row, 1)"
              >反核销</el-button
            >
            <el-button
              v-auth="'adminEdit'"
              type="text"
              size="small"
              @click="ordinaryEditor(scope.row, 2)"
              >管理员-编辑</el-button
            >
            <el-button
              v-auth="'adminReverse'"
              type="text"
              size="small"
              @click="reverseVerification(scope.row, 2)"
              >管理员-反核销</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size="query.pageSize"
        @current-change="payCurrentChange"
        class="pagation"
        layout="prev, pager, next, jumper"
        :total="query.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="编辑"
      :before-close="ordinaryEditoreCanel"
      :visible.sync="ordinaryEditoreDialog"
      width="30%"
    >
      <el-form ref="form" :model="ordinaryEditoreData" label-width="100px">
        <el-form-item label="本次核销金额：">
          <el-col :span="6">
            <el-input
              type="text"
              placeholder=""
              v-model.trim="ordinaryEditoreData.verifyAmount"
              @change="verifyAmountInput"
              oninput="value=value.replace(/^([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
            ></el-input>
          </el-col>
        </el-form-item>
        <div class="tips ordinaryEditoreTips">
          剩余待核销金额：{{ ordinaryEditoreData.leftAmount }}
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ordinaryEditoreCanel">取 消</el-button>
        <el-button type="primary" @click="ordinaryEditoreSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="reverseDialogVisible" width="30%">
      <span>确认反核销本笔核销记录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reverseDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="reverseDialogBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _paymentService from "@/service/payment-inquiry-service";

export default {
  data() {
    return {
      payInfos: null,
      payTime: [],
      verifyTime:[],
      query: {
        accountName: "",
        payStartTime: "",
        payEndTime: "",
        verifyTimeStart: "",
        verifyTimeEnd: "",
        verifyCode: "",
        flowCode: "",
        tradeNo: "",
        contractAccountName: "",
        orderNo: "",
        orderType: "",
        collectionPeriod: "",
        customerName: "",
        ownerUserName: "",
        pageIndex: 1,
        pageSize: 20,
        total: 0,
      },
      orderTypeList: null,
      ordinaryEditoreDialog: false,
      ordinaryEditoreData: {
        verifyAmount: "",
        leftAmount: "",
        flowCode: "",
        verifyCode: "",
      },
      verifyOuterOrderDialog: false,
      reverseDialogVisible: false,
      tableData: [
        {
          flowCode: "",
          systemId: "",
          orderNo: "",
          refundOrderNo: "",
          customerName: "",
          orderTypeName: "",
          returnAmount: "",
          refundReturnAmount: "",
          totalUsableAmount: "",
          verifyAmount: "",
          operatorName: "",
          operatorDepartmentName: "",
          companyName: "",
          collectionPeriod: "",
          verifyRemainTotal: "",
        },
      ],
      queryCollectionPeriod: {
        flowCode: "",
        payTime: "",
      },

      type: "",
      fullscreenLoading: false,
      timer: null
    };
  },
  mounted() {
    this.getOrderType();
    this.getVerifDeadlineFun()
    this.getPaymentList()
  },
  methods: {
    getOrderType() {
      _paymentService.paymentTypeList({ state: "OrderTypeNewEnum" }, (res) => {
        this.orderTypeList = res;
      });
    },
    getQueryCollection(row) {
      this.queryCollectionPeriod.flowCode = row.flowCode;
      this.queryCollectionPeriod.payTime = row.payTime;
      _paymentService.getQueryCollectionPeriod(
        this.queryCollectionPeriod,
        (res) => {
          this.tableData[0].collectionPeriod = res.collectionPeriod;
        }
      );
    },
    getPaymentList(pageIndex) {
      if (pageIndex) this.query.pageIndex = pageIndex;
      else this.query.pageIndex = 1;

      if (this.payTime) {
        this.query.payStartTime = this.payTime[0];
        this.query.payEndTime = this.payTime[1];
      } else {
        this.query.payStartTime = "";
        this.query.payEndTime = "";
      }
      if (this.verifyTime) {
        this.query.verifyTimeStart = this.verifyTime[0];
        this.query.verifyTimeEnd = this.verifyTime[1];
      } else {
        this.query.verifyTimeStart = "";
        this.query.verifyTimeEnd = "";
      }

      _paymentService.orderVerifyList(
        this.query,
        (response, total) => {
          // 请求成功
          if (response) {
            this.payInfos = response;
          }
          this.query.total = total;
        },
        (response) => {
          this.$notify({
            message: response,
            type: "warning",
          });
        }
      );
    },

    payCurrentChange(pageIndex) {
      this.getPaymentList(pageIndex);
    },

    reset() {
      location.reload();
    },
    getVerifDeadlineFun() {
      _paymentService.getVerifDeadline((res) => {
        this.getVerifDeadlineData = res;
      });
    },

    exportFun() {

      if (this.payTime) {
        this.query.payStartTime = this.payTime[0];
        this.query.payEndTime = this.payTime[1];
      } else {
        this.query.payStartTime = "";
        this.query.payEndTime = "";
      }
      if (this.verifyTime) {
        this.query.verifyTimeStart = this.verifyTime[0];
        this.query.verifyTimeEnd = this.verifyTime[1];
      } else {
        this.query.verifyTimeStart = "";
        this.query.verifyTimeEnd = "";
      }
      let _this = this
      this.fullscreenLoading = true
      _paymentService.exportVerifyExcel(
        this.query,
        (response) => {

          if (response.state == 0) {
                clearInterval( _this.timer)
                  _this.timer = setInterval(() => {
                    _this.exportFun()
                  },1000)
              } else if (response.state == 1) {
                  clearInterval( _this.timer)  
                  _this.fullscreenLoading = false            
                  window.location.href =  response.url                          
              }

        },
        response => {
          clearInterval(_this.timer)
          this.$notify({
            message: response,
            type: "warning",
          });
          _this.fullscreenLoading = false
        }
      );
    },

    verifyAmountInput(value) {
      this.ordinaryEditoreData.verifyAmount = value;
      _paymentService.queryLeftAmount(this.ordinaryEditoreData, (res) => {
        this.ordinaryEditoreData.leftAmount = res.leftAmount;

      }, (res) => {
          this.$notify({
            message: res,
            type: "warning",
          });
        }
      );
    },

    ordinaryEditoreCanel() {
      this.ordinaryEditoreDialog = false;
      this.ordinaryEditoreData.verifyAmount = ""
      this.ordinaryEditoreData.leftAmount = ""
    },
    externalOrders(row) {
      this.getQueryCollection(row);
      this.tableData[0].flowCode = row.flowCode;
      this.tableData[0].verifyRemainTotal = row.verifyRemainTotal;
      this.tableData[0].systemId = query.systemId;
      this.verifyOuterOrderDialog = true;
    },
    verifyOuterOrderCanel() {
      this.verifyOuterOrderDialog = false;
    },
    ordinaryEditoreSubmit() {
      if (this.ordinaryEditoreData.verifyAmount == "") {
        this.$notify({
              message: '请输入本次核销金额',
              type: "warning",
        });
        return
      }
      if (this.type == 1) {
        var Service = _paymentService.updateVerifyAmount;
      } else {
        var Service = _paymentService.updateVerifyAmountAdmin;
      }
      Service(
        this.ordinaryEditoreData,
        (response) => {
          this.$notify({
            message: "编辑成功",
            type: "success",
          });
          this.getPaymentList();
          this.ordinaryEditoreDialog = false;
     
        },
        (response,data) => {
  
          if (this.type == 1 && data && data.close) {
            this.$notify({
              message: response,
              type: "warning",
           });
           this.ordinaryEditoreDialog = false;
           this.getPaymentList()
          }else{
            this.$notify({
              message: response,
              type: "warning",
           });
          }
        }
      );
    },
    handleOrdersClick(row) {
      this.$router.push({
        path: "/verification-orders-detail",
        query: {
          id: row.id,
        },
      });
    },
    ordinaryEditor(row, type) {
      this.ordinaryEditoreDialog = true;
      this.ordinaryEditoreData.flowCode = row.flowCode;
      this.ordinaryEditoreData.verifyCode = row.verifyCode;
      this.type = type;
      this.ordinaryEditoreData.verifyAmount = ""
      this.ordinaryEditoreData.leftAmount = ""
    },
    reverseVerification(row, type) {
      this.ordinaryEditoreData.flowCode = row.flowCode;
      this.ordinaryEditoreData.verifyCode = row.verifyCode;
      this.reverseDialogVisible = true;
      this.type = type;
    },
    reverseDialogBtn() {
      let data = {
        verifyCode: this.ordinaryEditoreData.verifyCode,
        flowCode: this.ordinaryEditoreData.flowCode,
      };
      if (this.type == 1) {
        var Service = _paymentService.verifyReverse;
      } else {
        var Service = _paymentService.verifyReverseAdmin;
      }

      Service(
        data,
        (response) => {
          this.$notify({
            message: "成功",
            type: "success",
          });
        
          this.getPaymentList();
          this.reverseDialogVisible = false;
        },
        (response,data) => {
          if (this.type == 1 && data && data.close) {
              this.$notify({
                message: response,
                type: "warning",
              });
              this.reverseDialogVisible = false;
              this.getPaymentList()
            }else{
              this.$notify({
                message: response,
                type: "warning",
              });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.wapper /deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;

}
.wapper /deep/.el-date-editor .el-range-input{
  width: 58%;
}
.wapper /deep/.el-date-editor .el-range-separator {
  padding: 0 1px;
}
/deep/.el-col-6 {
  padding-right: 4px!important;
}
.tips {
  color: red;
}
.times {
  margin-bottom: 20px;
}
.ordinaryEditoreTips {
  margin-left: 4px;
}
.wapper {
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.header {
  margin-bottom: 15px;
}

.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
  width: 100%;
}

.query-wapper::after {
  position: absolute;
  content: "筛选条件";
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}

.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
  flex: 1;
  width: 100%;
  overflow-y: scroll;
}

.button-wapper {
  margin-top: 10px;
}

.el-row {
  margin-bottom: 15px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
